module.exports = __webpack_public_path__ + "static/img/best_costume_design_block_10.5eb741e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/best_costume_design_block_10.jpg
// module id = 234
// module chunks = 0